import { createStore } from "vuex"
import VuexPersistence from "vuex-persist"
import doAsync from "./async-util"
import * as types from "./mutation-types"
import localforage from "localforage"

const local_store = localforage.createInstance({
  name: "pmstore",
});

const vuexPersist = new VuexPersistence({
  storage: local_store,
  reducer: (state) => {
    return JSON.parse(JSON.stringify(state));
  },
  asyncStorage: true,
});

let state_dict = {
  token: '',
  order: {},
  designs: [],
  orders: [],
  account: null,
  products: [], // service configured products
  discount_volumes: [],
  cartSpinnerActive: false,
  spinnerActive: false,
  notificationActive: false,
  notificationMessage: '',
  reseting: false,
  postContactData: null,
  putContactData: null,
  temporal_contact_data: null,
  image_bank: [],
  resetOrderNotificationShow: false,
  serviceFees: [],
  fixedVoucher: {},
  voucher: {},
  shippingVoucher: [],
  i18n: 'fi',
  selectedCategory: null,
  emailInUse: '',
  siteSettings: { ai_agent_enabled: true },
  landingNotification: { active: false, title: '', text: '', image: null }
}

let store_config = {
  state() {
    return state_dict
  },
  mutations: {
    setAuth(state, token) {
      state.token = token
    },
    partialReset(state) {
      let token = state.token
      let account = state.account
      Object.assign(state, state_dict)
      state.token = token
      state.account = account
    },
    setSpinnerState(state, spinnerState) {
      state.spinnerActive = spinnerState
    },
    setCartSpinnerState(state, spinnerState) {
      state.cartSpinnerActive = spinnerState
    },
    setProducts(state, data) {
      state.products = data
    },
    setServiceFees(state, data) {
      state.serviceFees = data
    },
    setOrder(state, data) {
      state.order = data
    },
    setDesigns(state, data) {
      state.designs = data
    },
    setOrders(state, data) {
      state.orders = data
    },
    setAccount(state, data) {
      state.account = data
    },
    seti18n(state, value) {
      state.i18n = value
    },
    setVolumesDiscount(state, data) {
      state.discount_volumes = data
    },
    setNotificationActiveState(state, data) {
      state.notificationActive = data['notificationState']
      state.notificationMessage = data['message']
    },
    setReseting(state, reset) {
      state.reseting = reset
    },
    setFixedVoucher(state, data) {
      state.fixedVoucher = data
    },
    setVoucher(state, data) {
      state.voucher = data
    },
    setShippingVoucher(state, data) {
      state.shippingVoucher = data
    },
    setImagesBank(state, data) {
      state.image_bank = data
    },
    setResetOrderNotificationShow(state, value) {
      state.resetOrderNotificationShow = value
    },
    resetStore(state) {
      Object.assign(state, state_dict)
    },
    setSelectedCategory(state, category) {
      state.selectedCategory = category
    },
    setLandingData(state, data) {
      state.landingData = data
    },
    setEmailInUse(state, email) {
      state.emailInUse = email
    },
    setSiteSettings(state, data) {
      state.siteSettings = data
    },
    setLandingNotification(state, data) {
      state.landingNotification = data
    }
  },
  getters: {
    getToken(state) {
      return state.token
    },
    getOrderData(state) {
      return state.order
    },
    getVolumesDiscount: (state) => (product, material = '') => {
      // we do split material, and if it exists we get the number that matches the variant id
      let prodObject = store.getters.getProductById(product)
      if (prodObject != undefined) {
        if (prodObject.resource_type == 'StoreProduct' || prodObject.resource_type == 'Lid') {
          return [{
            id: product,
            price: prodObject.price,
            product_id: product,
            total: prodObject.price,
            volume_point: 1
          }]
        }
      }
      return state.discount_volumes.filter(prod => {
        return prod.product_id == product
      })
    },
    getCartSpinnerState(state) {
      return state.cartSpinnerActive
    },
    getProducts(state) {
      return state.products
    },
    getCustomizableProducts(state) {
      return state.products.filter(p => p.customizable)
    },
    getCups(state) {
      return state.products.filter(el => el.resource_type == 'Cup')
    },
    getPlates(state) {
      return state.products.filter(el => el.resource_type == 'Plate')
    },
    getProductDescription: (state) => (productId) => {
      if (state.i18n) return state.products.find(el => el.id == productId).description[`${state.i18n}`]
      return state.products.find(el => el.id == productId).description['fi']
    },
    getDesignServiceFee(state) {
      const DESIGN_SERVICE_ID = 1
      return state.serviceFees.find((el) => el.id == DESIGN_SERVICE_ID)
    },
    getImagesBank(state) {
      return function (category) {
        return state.image_bank.filter(function (img) {
          return img.category === category
        })
      }
    },
    getProductById: (state) => (id) => {
      return state.products.find(prod => {
        return prod.id == id
      })
    },
    getProductBySlug: (state) => (slug) => {
      return state.products.find(prod => {
        return prod.slug == slug
      })
    },
    getFixedVoucher(state) {
      return state.fixedVoucher
    },
    getVoucher(state) {
      return state.voucher
    },
    getShippingVoucher(state) {
      return state.shippingVoucher
    },
    getNotificationActive(state) {
      return state.notificationActive
    },
    getResetOrderNotificationShow(state) {
      return state.resetOrderNotificationShow
    },
    getNotificationMessage(state) {
      return state.notificationMessage
    },
    getItemsTotalAmount: (state) => {
      let total = 0
      if (state.order == null || state.order == {}) {
        return 0
      }
      let items = state.order.items.filter(el => el.draft === false)
      items.forEach(function (item) {
        total += item.amount
      })
      let forms = state.order.orderforms.filter(el => el.draft === false)
      forms.forEach(function (item) {
        total += item.amount
      })
      return total
    },
    getItemsTotalAmountByProduct: (state) => (productId, material = '') => {
      let total = 0
      if (state.order == null || state.order == {} || state.order.items == undefined) {
        return 0
      }
      if (material.length > 0) {
        // For plate cases, group by variant id + product id
        let plate_items = state.order.items.filter(el => el.draft === false && el.product == productId && el.material == material)
        plate_items.forEach(function (item) {
          total += item.amount
        })
      } else {
        let items = state.order.items.filter(el => el.draft === false && el.product == productId)
        items.forEach(function (item) {
          total += item.amount
        })
        let forms = state.order.orderforms.filter(el => el.draft === false && el.product == productId)
        forms.forEach(function (item) {
          total += item.amount
        })
      }

      return total
    },
    getContactData: (state) => {
      if (state.postContactData != null) {
        return state.postContactData
      } else {
        return state.temporal_contact_data
      }
    },
    getReseting(state) {
      return state.reseting
    },
    getSavedItems: (state) => {
      if (state.order == null || state.order.items == undefined) {
        return []
      }
      return state.order.items.filter(el => el.draft === false)
    },
    getDesignedItems: (state) => {
      return state.designs
    },
    getOrdersItems: (state) => {
      return state.orders
    },
    getAccountInfo: (state) => {
      return state.account
    },
    getNonDraftOrderForms: (state) => {
      if (state.order == null || state.order.orderforms == undefined) {
        return []
      }
      return state.order.orderforms.filter(el => el.draft === false)
    },
    getEmailInUse: (state) => {
      return state.emailInUse
    },
    selectedCategory: state => state.selectedCategory,
    landingData: state => state.landingData,
    aiAgentEnabled: state => state.siteSettings.ai_agent_enabled,
    getLandingNotification: state => state.landingNotification
  },
  actions: {
    getAuthenticate(store, { email, password, force = false }) {
      if (!force || store.state.token != '') {
        return
      }
      return doAsync(store, {
        url: `login/`,
        mutationTypes: types.GET_AUTHENTICATE,
        method: 'post',
        data: {
          email: email,
          password: password,
        },
      }).then((res) => {
        if (res.status === 200) {
          store.commit('setAuth', res.data.token)
        }
        return res
      })
    },
    getProducts(store) {
      return doAsync(store, {
        url: `products/`,
        mutationTypes: types.GET_PRODUCTS,
        method: 'get',
      }).then(() => {
        store.commit('setProducts', store.state.getProductsData)
      })
    },
    postOrder(store) {
      return doAsync(store, {
        url: `order/`,
        mutationTypes: types.POST_ORDER,
        method: 'post',
      }).then(() => {
        store.commit('setOrder', store.state.postOrderData)
      })
    },
    cloneOrder(store, order_id) {
      return doAsync(store, {
        url: `order/${order_id}/clone/`,
        mutationTypes: types.CLONE_ORDER,
        method: 'post',
      }).then(() => {
        store.commit('setOrder', store.state.cloneOrderData)
      })
    },
    partialUpdateOrder(store, orderData) {
      orderData['order_number'] = store.state.order.order_number
      return doAsync(store, {
        url: 'order/patch/',
        mutationTypes: types.PARTIAL_UPDATE_ORDER,
        method: 'patch',
        data: orderData,
      }).then(() => {
        store.commit('setOrder', store.state.partialUpdateOrderData)
      })
    },
    getOrder(store) {
      let order_number = store.state.order.order_number
      return doAsync(store, {
        url: `order/${order_number}/`,
        mutationTypes: types.GET_ORDER,
        method: 'get',
      }).then((res) => {
        if (res.status == 404) {
          if (store.state.account == null) {
            store.commit('resetStore')
          } else {
            store.commit('partialReset')
          }
        } else {
          store.commit('setOrder', store.state.getOrderData)
        }
      })
    },
    getDesigns(store) {
      return doAsync(store, {
        url: `my-designs/`,
        mutationTypes: types.GET_DESIGNS,
        method: 'get',
      }).then((res) => {
        if (res.status == 404) {
          if (store.state.account == null) {
            store.commit('resetStore')
          } else {
            store.commit('partialReset')
          }
        } else {
          store.commit('setDesigns', store.state.getDesignsData)
        }
      })
    },
    getOrders(store) {
      return doAsync(store, {
        url: `my-orders/`,
        mutationTypes: types.GET_ORDERS,
        method: 'get',
      }).then((res) => {
        if (res.status == 404) {
          if (store.state.account == null) {
            store.commit('resetStore')
          } else {
            store.commit('partialReset')
          }
        } else {
          store.commit('setOrders', store.state.getOrdersData)
        }
      })
    },
    getAccount(store) {
      return doAsync(store, {
        url: `account/`,
        mutationTypes: types.GET_ACCOUNT,
        method: 'get',
      }).then((res) => {
        if (res.status == 404) {
          if (store.state.account == null) {
            store.commit('resetStore')
          } else {
            store.commit('partialReset')
          }
        } else {
          store.commit('setAccount', store.state.getAccountData)
        }
      })
    },
    postItem(store, data) {
      return doAsync(store, {
        url: `item/`,
        mutationTypes: types.POST_ITEM,
        method: 'post',
        data: data,
      })
    },
    updateItem(store, data) {
      return doAsync(store, {
        url: `item/${data['id']}/`,
        mutationTypes: types.UPDATE_ITEM,
        method: 'patch',
        data: data,
      })
    },
    listDiscountVolumes(store) {
      return doAsync(store, {
        url: `volume-discount/`,
        mutationTypes: types.LIST_DISCOUNT_VOLUMES,
        method: 'get',
      }).then(() => {
        store.commit('setVolumesDiscount', store.state.listDiscountVolumesData)
      })
    },
    listShippingVoucher(store) {
      return doAsync(store, {
        url: `shipping-price/`,
        mutationTypes: types.LIST_SHIPPING_VOUCHER,
        method: 'get',
      }).then(() => {
        store.commit('setShippingVoucher', store.state.listShippingVoucherData)
      })
    },
    deleteItem(store, item_id) {
      return doAsync(store, {
        url: `item/${item_id}/`,
        mutationTypes: types.DELETE_ITEM,
        method: 'delete',
      })
    },
    postRequestOrderForm(store, data) {
      return doAsync(store, {
        url: `requestorderform/`,
        mutationTypes: types.POST_REQUEST_ORDER_FORM,
        method: 'post',
        data: data,
      })
    },
    getRequestOrderForm(store, id) {
      return doAsync(store, {
        url: `requestorderform/${id}/`,
        mutationTypes: types.GET_REQUEST_ORDER_FORM,
        method: 'get'
      })
    },
    updateRequestOrderForm(store, data) {
      // True formData
      return doAsync(store, {
        url: `requestorderform/${data.get('id')}/`,
        mutationTypes: types.UPDATE_REQUEST_ORDER_FORM,
        method: 'patch',
        data: data
      })
    },
    deleteRequestOrderForm(store, item_id) {
      return doAsync(store, {
        url: `requestorderform/${item_id}/`,
        mutationTypes: types.DELETE_REQUEST_ORDER_FORM,
        method: 'delete',
      })
    },
    postContact(store, formData) {
      formData['order'] = store.state.order.order_number
      return doAsync(store, {
        url: 'contact/',
        mutationTypes: types.POST_CONTACT,
        method: 'post',
        data: formData,
      })
    },
    updateContact(store, formData) {
      formData['order'] = store.state.order.order_number
      return doAsync(store, {
        url: `contact/${store.state.postContactData.id}/`,
        mutationTypes: types.PUT_CONTACT,
        method: 'put',
        data: formData,
      })
    },
    listImageBank(store) {
      return doAsync(store, {
        url: `image-bank/`,
        mutationTypes: types.IMAGE_BANK,
        method: 'get',
      }).then(() => {
        store.commit('setImagesBank', store.state.imageBankData)
      })
    },
    addVoucher(store, data) {
      return doAsync(store, {
        url: `voucher/${data['code']}/`,
        mutationTypes: types.ADD_VOUCHER,
      })
    },
    postNewsletter(store, data) {
      return doAsync(store, {
        url: 'newsletter/',
        mutationTypes: types.POST_NEWSLETTER,
        method: 'post',
        data: data,
      })
    },
    getServiceFees(store) {
      return doAsync(store, {
        url: `service-fee/`,
        mutationTypes: types.GET_SERVICE_FEES,
        method: 'get',
      }).then(() => {
        store.commit('setServiceFees', store.state.getServiceFeesData)
      })
    },
    postContactForm(store, data) {
      return doAsync(store, {
        url: `contact-form/`,
        mutationTypes: types.POST_CONTACT_FORM,
        method: 'post',
        data: data,
      })
    },
    listLandingData(store) {
      return doAsync(store, {
        url: `landing-data/`,
        mutationTypes: types.GET_LANDING_DATA,
        method: 'get',
      }).then(() => {
        store.commit('setLandingData', store.state.getLandingDataData)
      })
    },
    getSiteSettings(store) {
      return doAsync(store, {
        url: `site-settings/`,
        mutationTypes: types.GET_SITE_SETTINGS,
        method: 'get',
      }).then(() => {
        store.commit('setSiteSettings', store.state.getSiteSettingsData)
      })
    },
    getLandingNotification(store) {
      return doAsync(store, {
        url: `landing-notification/`,
        mutationTypes: types.GET_LANDING_NOTIFICATION,
        method: 'get',
      }).then(() => {
        store.commit('setLandingNotification', store.state.getLandingNotificationData)
      })
    },
    createPaytrailSession(store, data) {
      let order_number = store.state.order.order_number
      return doAsync(store, {
        url: `order/${order_number}/create_paytrail_session/`,
        mutationTypes: types.PAYTRAIL_SESSION,
        method: 'post',
        data: data
      })
    },
    postUser(store, data) {
      return doAsync(store, {
        url: `auth/register/`,
        mutationTypes: types.POST_USER,
        method: 'post',
        data: data,
      }).then((res) => {
        const email = res?.data?.email
        if (email) {
          store.commit('setEmailInUse', email)
        }
        if (res.status === 201) {
          store.commit('setAuth', res.data.token)
        }
      })
    },
    postChangePassword(store, formData) {
      return doAsync(store, {
        url: 'auth/change-password/',
        mutationTypes: types.CHANGE_PASSWORD,
        method: 'post',
        data: formData,
      })
    },
    postResetPassword(store, formData) {
      return doAsync(store, {
        url: 'auth/reset-password/',
        mutationTypes: types.RESET_PASSWORD,
        method: 'post',
        data: formData,
      })
    },
    postUpdateResetPassword(store, formData) {
      return doAsync(store, {
        url: 'auth/update-reset-password/',
        mutationTypes: types.RESET_UPDATE_PASSWORD,
        method: 'post',
        data: formData,
      })
    },
    postAiDesign(store, data) {
      return doAsync(store, {
        url: 'ai-design/',
        mutationTypes: types.POST_AI_DESIGN,
        method: 'post',
        data: data,
      })
    },
  },
  plugins: [vuexPersist.plugin],
}

/*
 * For each async mutation, dynamically add the three mutations:
 * SUCCESS - write the response to the store using the `stateKey` property
 * PENDING - set the `loadingKey` property in the store to true
 * FAILURE - Set `loadingKey` to false, and `errorCode` - for example 401, 404...
 *
 * stateKey, errorCode and loadingKey are prepended with the name of the action,
 * for example an action getData would lead to:
 *
 * mutations:
 *   GET_DATA_SUCCESS,
 *   GET_DATA_PENDING,
 *   GET_DATA_FAILURE
 *
 * state:
 *   getDataLoadingKey,
 *   getDataStateKey,
 *   getDataErrorCode
 *
 * For all mutations following defaults are applied:
 *   getDataLoadingKey = false
 *   getDataStateKey = null
 *   getDataStatusCode = null
 *   getDataErrorCode = null
 */
Object.keys(types).forEach((type) => {
  // add the initial state
  state_dict[types[type].loadingKey] = false
  state_dict[types[type].stateKey] = null
  state_dict[types[type].statusCode] = null
  state_dict[types[type].FAILURE] = null

  // add the mutation
  store_config['mutations'][types[type].BASE] = (state, payload) => {
    switch (payload.type) {
      case types[type].PENDING:
        state[types[type].loadingKey] = payload.value
        return state[types[type].loadingKey]

      case types[type].SUCCESS:
        state[types[type].statusCode] = payload.statusCode
        state[types[type].FAILURE] = null
        state[types[type].stateKey] = payload.data
        return state[types[type].stateKey]

      case types[type].FAILURE:
        state[types[type].statusCode] = payload.statusCode
        state[types[type].FAILURE] = payload.error
        return state[types[type].FAILURE]
    }
  }
})

const store = createStore(store_config)

export default store


